/**
 * Purpose:
 * Manages window resize listener for ProtectedLayoutClient component.
 *
 * Responsibility:
 * - Setup resize event listener
 * - Close mobile menu when desktop breakpoint is reached
 * - Cleanup listener on unmount
 */

'use client';

import { useEffect, startTransition } from 'react';
import { DESKTOP_BREAKPOINT } from '@/util/constants/breakpoints';

export function useProtectedLayoutResize(
  setMounted: (mounted: boolean) => void,
  onDesktopResize: () => void
) {
  // Set mounted flag and setup resize listener after mount
  useEffect(() => {
    // Set mounted flag to enable transitions
    startTransition(() => {
      setMounted(true);
    });

    // Listen for resize events
    const checkDesktop = () => {
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        onDesktopResize();
      }
    };

    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    return () => window.removeEventListener('resize', checkDesktop);
  }, [onDesktopResize, setMounted]);
}
